import { Link } from 'react-router-dom';
import type { NeighborhoodSummary } from '../models/EventModel';
import NeighborhoodCard from './NeighborhoodCard';
import styles from './PopularNeighborhoods.module.css';

interface PopularNeighborhoodsProps {
    citySlug: string;
    neighborhoods: NeighborhoodSummary[];
    eyebrow: string;
    title: string;
    layout?: 'default' | 'home';
}

export default function PopularNeighborhoods({
    citySlug,
    neighborhoods,
    eyebrow,
    title,
    layout = 'default'
}: PopularNeighborhoodsProps) {
    if (neighborhoods.length === 0) return null;

    return <section className={styles.section} aria-label={title}>
        <div className={styles.heading}>
            <div>
                <p className={styles.eyebrow}>{eyebrow}</p>
                <h2>{title}</h2>
            </div>
            <Link to={`/${encodeURIComponent(citySlug)}/quartiers`} className={styles.allNeighborhoodsLink}>
                Voir tous les quartiers <span aria-hidden="true">→</span>
            </Link>
        </div>
        <div className={styles.grid}>
            {neighborhoods.map((neighborhood) => <NeighborhoodCard
                key={neighborhood.id}
                citySlug={citySlug}
                neighborhood={neighborhood}
                className={layout === 'home' ? styles.homeCard : ''}
            />)}
        </div>
    </section>;
}
